import styled from 'styled-components';
import { Button } from '~/components/Button';

export const ButtonLarge = styled(Button)`
  min-width: 150px;
`;
try {
    // @ts-ignore
    ButtonLarge.displayName = "ButtonLarge";
    // @ts-ignore
    ButtonLarge.__docgenInfo = { "description": "", "displayName": "ButtonLarge", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ButtonLarge/ButtonLarge.tsx#ButtonLarge"] = { docgenInfo: ButtonLarge.__docgenInfo, name: "ButtonLarge", path: "src/components/ButtonLarge/ButtonLarge.tsx#ButtonLarge" };
}
catch (__react_docgen_typescript_loader_error) { }